import type { AddressAttributes as GQLInput } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** Every field nullable: a null clears the column. An absent `id` creates rather than updates. */
export type AddressInput = {
  id?: number | null;
  street1?: string | null;
  street2?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  _destroy?: boolean | null;
};

const GQL_FIELDS = [
  '_destroy', 'city', 'country', 'id', 'postalCode', 'state', 'street1', 'street2',
] as const;

export const toGqlInput = (address: AddressInput): GQLInput =>
  take<GQLInput, AddressInput>(address, ...GQL_FIELDS);
